module.exports = {
  messages: {
    valid: 'Valid',
    kindlyProvide: "Kindly Provide",
    kindlySelect: "Kindly Select",
    noDataAvailable: "No Data Available",
    apiError: "No response from server.please try later..",
    transferMsgSuccess: 'You have Successfully completed the transfer',
    transferMsgFailure: 'Transaction failed. Invalid Vken 2FA Code.'
  },
  flag: {
    success: 'S',
    failure: 'F'
  },
  stepper: {
    stepOne: 'Transfer',
    stepTwo: '2FA OTP',
    stepThree: 'Transaction Status'
  },
  fundTransfer: {
    token: "Vken 2FA OTP",
    qrCode: 'QRCode',
    remarks: 'Remarks',
    amount: 'Amount',
    mobileNo: 'Mobile',
    fromaccount: 'From Account',
    name: ' Beneficiary Name',
    accountNo: 'Beneficiary Account Number',
  },
  placeholderLabel: {
    select: "Select",
  },
  apiError: {
    status: {
      status: "F",
      message: "No response from server.please try later..",
    },
  },
  entryFormLabel: {

  },
};
